/** The product's name and words, in one place (rename it here). */
export const BRAND = {
  name: 'Cutroom',
  tagline: 'Edit videos in your browser. Your footage never leaves your computer.',
  /** The project file's extension (Duo Studio's `.duovideo` projects open too). */
  ext: '.cutroom',
  /** Where the source lives; the landing page links to it when it's set. */
  repo: '',
  license: 'MIT',
  /** Who makes it. */
  maker: 'Indie Duo',
  makerUrl: 'https://indieduo.in',
} as const;
